import moment from 'moment';
import numeral from 'numeral';

// load a locale
numeral.register('locale', 'ru', {
  delimiters: {
    thousands: ' ',
    decimal: ','
  },
  abbreviations: {
    thousand: 'тыс',
    million: 'млн',
    billion: 'млрд',
    trillion: 'трлн'
  },
  currency: {
    symbol: 'т'
  }
});

// switch between locales
numeral.locale('ru');

export const numberFormatter = item => numeral(item).format('0.00 a');

export const formatDate = (date, format = 'DD.MM.YYYY') => {
  return date ? moment(date).format(format) : '-';
};

export const formatDateTime = date => {
  return moment(date).format('DD.MM.YYYY HH:mm:ss');
};

// Adds the thousands separator
export const numberWithThousands = x => {
  return x.toLocaleString('ru');
};

export const numberWithCommas = (
    x,
    delimiter = ',',
) => {
  const numStr = String(Math.round(Number(x) * 10) / 10);
  let [integerPart, decimalPart] = numStr.split('.');

  let sign = '';
  if (integerPart.startsWith('-')) {
    sign = '-';
    integerPart = integerPart.slice(1);
  }

  let result = '';
  let groupCounter = 0;

  for (let i = integerPart.length - 1; i >= 0; i--) {
    const ch = integerPart[i];
    if (groupCounter === 3) {
      result = delimiter + result;
      groupCounter = 0;
    }
    result = ch + result;
    groupCounter++;
  }

  const formattedInt = sign + result;
  return decimalPart ? `${formattedInt}.${decimalPart}` : formattedInt;
};